import { uniqBy } from 'lodash-es';
import { useBIQueryBuilder } from '~/bi/composables/useBIQueryBuilder.js';

export function useBIColumnPicker(props, type = 'filters') {
  const { constructFieldName, constructColumnAlias } = useBIQueryBuilder();

  const getPreviousStageFields = () => props.previousStageFields;

  const getPreviousStageFieldsWithPath = () => getPreviousStageFields().map(field => ({ ...field, field: constructFieldName({ label: field.field || field.alias, table_name: 'results' }), path: ['Previous stage'] }));

  const getCurrentStageFields = () => props.fields.map(field => ({ ...field, type: field.field_type, label: field.alias, field: field.alias }));

  const getVisibleFields = fn => fn().filter(field => !field.skip);

  const getCurrentStageHiddenFieldsMap = () => getCurrentStageFields().reduce((acc, field) => {
    if (field.skip)
      acc[field.alias] = true;
    return acc;
  }, {});

  const filterPreviousFieldsBasedOnCurrentStage = fn => fn().filter(field => !getCurrentStageHiddenFieldsMap()[field.alias]);

  const getPreviousStageVisibleFields = () => filterPreviousFieldsBasedOnCurrentStage(getPreviousStageFields);

  const getCurrentStageVisibleFields = () => getVisibleFields(getCurrentStageFields);

  // const getAllFields = () => uniqBy([...getPreviousStageFields(), ...getCurrentStageFields()], 'alias');

  const getAllVisibleFields = () => uniqBy([...getPreviousStageVisibleFields(), ...getCurrentStageVisibleFields()], 'alias');

  const getAllVisibleFieldsWithResultsPrefix = () => [...getPreviousStageVisibleFields().map(field => ({ ...field, alias: constructColumnAlias({ table_name: 'Previous stage', column_name: field.alias }), field: constructFieldName({ label: field.alias, table_name: 'results' }), path: ['Previous stage'] })), ...getCurrentStageVisibleFields()];

  const filterOptions = () => [{ label: `Stage ${props.stageIndex + 1}`, columns: getAllVisibleFieldsWithResultsPrefix(), tables: props.tables, keep_open: true }];

  const sortOptions = () => [{ label: `Stage ${props.stageIndex + 1}`, columns: props.ignorePreviousStageColumns ? getCurrentStageVisibleFields() : getAllVisibleFields(), tables: [] }];

  const columnPickerOptions = () => [{ label: `Stage ${props.stageIndex + 1}`, columns: getPreviousStageFieldsWithPath(), keep_open: true, tables: props.tables }];

  const joinsOptions = () => [{ label: `Stage ${props.stageIndex + 1}`, columns: getPreviousStageFieldsWithPath(), keep_open: true, tables: props.tables }];

  const windowFunctionOptions = () => [{ label: `Stage ${props.stageIndex + 1}`, columns: getAllVisibleFields(), tables: [] }];

  const expressionEditorOptions = () => [
    ...props.tables.map((table, table_index) => table.columns.map(column => ({ label: column.label, name: column.field, type: column.type, path: table_index > 0 ? [table.label, ...(column.path || [])] : column.path }))).flat(),
    ...getPreviousStageFields().map(field => ({
      label: field.alias || field.label,
      name: constructFieldName({ label: field.alias, table_name: 'results' }),
      is_aggregation: field.is_aggregation,
      type: field.type,
      path: ['Previous stage'],
    })),
    ...getCurrentStageFields().map(field => ({
      label: field.alias || field.label,
      name: field.alias || field.name,
      is_aggregation: field.is_aggregation,
      type: field.type,
    })),
  ];

  const options_map = {
    filters: filterOptions,
    sort: sortOptions,
    column_picker: columnPickerOptions,
    joins: joinsOptions,
    expression: expressionEditorOptions,
    settings: windowFunctionOptions,
  };

  const stages = computed(options_map[type]);

  return { stages, columns: stages };
}
